import PropTypes from 'prop-types';
import styles from './LeadText.module.scss';

export default function LeadText({ children }) {
  return (
    <div className={styles['lead-text']}>
      {children}
    </div>
  );
}

LeadText.propTypes = {
  /**
   * What goes in the LeadText
   */
  children: PropTypes.node.isRequired,
};
